export const projectData = {
    uffici: {
        titleKey: "catOffices",
        subtitleKey: "catOfficesSub",
        coverImage: "./assets/Progetti/Uffici Confai BG.jpg",
        images: [
            { src: "./assets/Progetti/Uffici Confai BG.jpg", alt: "Uffici Confai, Bergamo" },
            { src: "./assets/Progetti/Uffici foto sito Ellegi 01.png", alt: "Ufficio tecnico, Milano" },
            { src: "./assets/Progetti/Ufficio Studio di Progettazione Mantova 01.jpeg", alt: "Studio di Progettazione, Mantova" },
        ]
    },
    negozi: {
        titleKey: "catRetail",
        subtitleKey: "catRetailSub",
        coverImage: "./assets/Progetti/Centro Commerciale Merlata Bloom 08.jpg",
        images: [
            { src: "./assets/Progetti/Centro Commerciale Merlata Bloom 08.jpg", alt: "Merlata Bloom Milano" },
            { src: "./assets/Progetti/Showroom Intra 01.jpg", alt: "Showroom Intra Lighting, Slovenia" },
            { src: "./assets/Progetti/Showroom Intra 04.jpg", alt: "Showroom Intra Lighting, Slovenia" },
        ]
    },
    "spazi-esterni": {
        titleKey: "catOutdoor",
        subtitleKey: "catOutdoorSub",
        coverImage: "./assets/Progetti/Lago Iseo 01.jpeg",
        images: [
            { src: "./assets/Progetti/Lago Iseo 01.jpeg", alt: "Lago D'iseo" },
            { src: "./assets/Progetti/Lago Iseo 03.jpeg", alt: "Lago D'iseo" },
            { src: "./assets/Progetti/Lungolago-Iseo-08.png", alt: "Lungolago D'iseo" },
            { src: "./assets/Progetti/Lago Maggiore 03.jpg", alt: "Lago Maggiore, Lesa" },
            { src: "./assets/Progetti/Lesa 01.jpg", alt: "Lesa, Novara" },
            { src: "./assets/Progetti/Menzino 01.jpg", alt: "Menzino, Monte Isola" },
            { src: "./assets/Progetti/Menzino 04.jpg", alt: "Menzino, Monte Isola" },
            { src: "./assets/Progetti/Menzino 05.jpg", alt: "Menzino, Monte Isola" },
            { src: "./assets/Progetti/Piazza Portello 02.jpeg", alt: "Piazza Portello, Milano" },
            { src: "./assets/Progetti/Piazza Portello 03.jpeg", alt: "Piazza Portello, Milano" },
            { src: "./assets/Progetti/Ponte Sospeso 02.jpg", alt: "Ponte Sospeso, Clanezzo" },
            { src: "./assets/Progetti/Ponte Sospeso 03.jpg", alt: "Ponte Sospeso, Clanezzo" },
            { src: "./assets/Progetti/Basilica di San Martino 01.jpg", alt: "Basilica di San Martino, Treviglio" },
            { src: "./assets/Progetti/Basilica di San Martino 03.jpg", alt: "Basilica di San Martino, Treviglio" },
            { src: "./assets/Progetti/Palazzo Castiglioni 02.jpg", alt: "Palazzo Castiglioni, Milano" },
            { src: "./assets/Progetti/Palazzo Castiglioni 03.jpg", alt: "Palazzo Castiglioni, Milano" },
        ]
    },
    "chiese-musei": {
        titleKey: "catInteriors",
        subtitleKey: "catInteriorsSub",
        coverImage: "./assets/Progetti/Basilica di San Martino 01.jpg",
        images: [
            { src: "./assets/Progetti/Chiesa-San-Luca-02.png", alt: "Chiesa di San Luca, Brescia" },
            { src: "./assets/Progetti/Chiesa-San-Luca-04.png", alt: "Chiesa di San Luca, Brescia" },
            { src: "./assets/Progetti/Chiesa-San-Luca-08.png", alt: "Chiesa di San Luca, Brescia" },
            { src: "./assets/Progetti/Chiesa SS FIlippo e Giacomo 12.JPG", alt: "Chiesa SS Filippo e Giacomo, Gavardo" },
        ]
    },
    industria: {
        titleKey: "catIndustry",
        subtitleKey: "catIndustrySub",
        coverImage: "./assets/Progetti/Logistica-Coop-05.png",
        images: [
            { src: "./assets/Progetti/Logistica-Coop-05.png", alt: "Logistica Coop, Pieve Emanuele" },
        ]
    }
};
